import { SeasonContextType } from "hooks/use-season";
import { createContext } from "react";

const SeasonContext = createContext<SeasonContextType | undefined>(undefined);

export default SeasonContext;
